import { Currency } from "common/types/currencies";

export interface UnitCostResult {
  currency: string;
  unitCost: number;
}

export const findCurrency = (id: string, currencies: Currency[]) =>
  currencies.find((c) => c.id.toLowerCase() === id.toLowerCase());
